export default {
  editing() {
    return this.$route.params.edit
  }
}
